<template>
  <div class="student-layout">
    <!-- 学生端顶部导航栏 -->
    <StudentHeader />
    
    <!-- 主要内容区域 -->
    <div class="student-main">
      <div class="content-container">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import StudentHeader from './components/StudentHeader.vue'

const route = useRoute()

// 判断是否为首页
const isHomePage = computed(() => {
  return route.path === '/student/home'
})

// 监听路由变化，控制样式
watch(isHomePage, (newVal) => {
  if (newVal) {
    // 首页样式处理
    document.body.classList.add('student-page')
    document.body.classList.remove('teacher-page', 'admin-page')
  }
}, { immediate: true })

// 组件卸载时清理
onUnmounted(() => {
  document.body.classList.remove('student-page')
})
</script>

<style scoped>
.student-layout {
  min-height: 100vh;
  background-color: #f5f7fa;
  position: relative;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}

.student-main {
  flex: 1;
  background-color: transparent;
}

.content-container {
  background-color: white;
  padding: 20px;
  min-height: calc(100vh - 80px);
}

/* 移动端适配 */
@media (max-width: 768px) {
  .content-container {
    padding: 15px;
    min-height: calc(100vh - 70px);
  }
}

@media (max-width: 480px) {
  .content-container {
    padding: 10px;
    min-height: calc(100vh - 60px);
  }
}
</style>